<template>
  <div class="row">
    <div class="col">
      <w-input :model="schema.listNumber" />
    </div>

    <div class="col">
      <w-datepicker :model="schema.documentDate" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Komponent dla listy BiK
// @group ActionData
export default {
  components,
  props: {
    schema: { type: Object, required: false }
  }
};
</script>
